import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-chart-downloader',
    templateUrl: './chart-downloader.component.html',
    styleUrls: ['./chart-downloader.component.scss'],
    standalone: false
})
export class ChartDownloaderComponent implements OnInit {

  @Input() chartDownloaderClass: string = '';

  constructor() { }

  ngOnInit() {
  }

  // html2canvas is ~200KB and is only reached when someone actually downloads a
  // chart image, so it is loaded at that point rather than in the initial bundle.
  async downloadDiv(captureDiv:HTMLElement, chartTitle:string, chartUrl:string, section:string, donwloadBoxSize?) { 
    let chartDownloaderClass
    if (section === 'r-ics') chartDownloaderClass = '.chart-download-r-ics';
    if (section === 'data-expl-ineq-markers') chartDownloaderClass = '.chart-download-data-expl-ineq-markers'
    if (section === 'data-expl-area-comp') chartDownloaderClass = '.chart-download-data-expl-area-comp'
    if (section === 'data-expl-learning-disab') chartDownloaderClass = '.chart-download-data-expl-learning-disab'
    if (section === 'outcomes-hypert-categories') chartDownloaderClass = '.chart-download-outcomes-hypert-categories'
   
    const chartDownload: HTMLElement = document.querySelector(chartDownloaderClass) 
    const content = document.createElement('div')
    content.innerHTML = 
    `<div>
        <div style="display:flex; justify-content:space-between; padding-top:2rem; margin-bottom:4rem;">
          <h3 style="margin-left:2.5rem; margin-right:2.5rem">${chartTitle}</h3> 
          <h5 style="margin-right:2rem">                   
            <img src="/assets/images/cvd_prevent_mark.svg" height="45" alt="CVDPREVENT mark">
          </h5>
        </div>
        <div style="margin:2rem">
          <div class="chart"> </div>
        </div>
        <div style="margin-right:2.5rem; margin-left:2.5rem; margin-top:2rem; float:right; font-weight: lighter">${chartUrl}</div>       
    </div>`
    ;
    
    chartDownload.appendChild(content)
    chartDownload.style.width = donwloadBoxSize ? donwloadBoxSize.width : '1000px';
    chartDownload.style.height = donwloadBoxSize ? donwloadBoxSize.height : '670px';

    const chart: HTMLElement = document.querySelector('.chart')
    chart.style.margin = 'auto';
    chart.innerHTML = captureDiv.innerHTML  
     
    const html2canvas = (await import('html2canvas')).default;

    html2canvas(chartDownload).then(canvas => {
      const imageData = canvas.toDataURL('image/png');
      // Create a link element
      const downloadLink = document.createElement('a');
      downloadLink.href = imageData;
      downloadLink.download = chartTitle + '.png';
      // Append the link to the body
      document.body.appendChild(downloadLink);
      // Trigger a click on the link
      downloadLink.click();
      // Remove the link from the body
      document.body.removeChild(downloadLink);
      //remove downloadDiv from view
      chartDownload.removeChild(content)
      // restore chartDownload container original size
      chartDownload.style.height= '100%'; 
      chartDownload.style.width = '100%';
    });
  }


}
